<template>
  <base-box class="box-campaign">
    <div class="header">
      <div class="d-flex align-center">
        <i class="megaphone-icon fas fa-megaphone"></i>
        <p class="coupon-code field-title">{{ campaign.name }}</p>
      </div>
      <div class="d-flex flex-column">
        <base-badge
          :type="getCampaignStatus(campaign.status)"
          :name="getCampaignStatusName(campaign.status)"
          :absolute="false"
        />
      </div>
    </div>

    <div class="d-flex align-center justify-between mb_25">
      <div>
        <p class="field-title">Prévia de alcance</p>
        <p>
          {{
            typeof campaign.reachPreview == 'number'
              ? campaign.reachPreview
              : '-'
          }}
        </p>
      </div>
      <div class="text-right">
        <p class="field-title">Tipo da ação</p>
        <p>{{ getActionType(campaign.action) }}</p>
      </div>
    </div>

    <div class="funnels">
      <div class="funnel" :class="{ active: campaign.sends }">
        <div class="funnel-value">
          <p v-if="campaign.sends">{{ campaign.sends }}</p>
          <p v-else class="empty">---</p>
        </div>
        <div class="d-flex align-center funnel-name">
          <i class="fas fa-users" />
          <p class="ml_10">Envios</p>
        </div>
      </div>
      <div class="line" :class="{ active: campaign.clicks }"></div>
      <div class="funnel" :class="{ active: campaign.clicks }">
        <div class="funnel-value">
          <p v-if="campaign.clicks">{{ campaign.clicks }}</p>
          <p v-else class="empty">---</p>
        </div>
        <div class="d-flex align-center funnel-name">
          <i class="fas fa-mouse-pointer" />
          <p class="ml_10">Cliques</p>
        </div>
      </div>
      <div class="line" :class="{ active: campaign.conversions }"></div>
      <div class="funnel" :class="{ active: campaign.conversions }">
        <div class="funnel-value">
          <p v-if="campaign.conversions">
            {{ campaign.conversions }}
          </p>
          <p v-else class="empty">---</p>
        </div>
        <div class="d-flex align-center funnel-name">
          <i class="fas fa-analytics" />
          <p class="ml_10">Conversões</p>
        </div>
      </div>
    </div>

    <div class="d-flex align-center">
      <base-button
        v-if="!canUpdate(campaign) && !canPublish(campaign)"
        design="three"
        class="w-100"
        @click="changeRoute('detalhes-campanha', { name: campaign.id })"
        >Ver detalhes</base-button
      >

      <div
        v-if="canUpdate(campaign) && canPublish(campaign)"
        class="d-flex w-100"
      >
        <base-button
          design="two pink"
          class="w-100"
          @click="() => updateStatus(campaign)"
          >Publicar campanha</base-button
        >
        <base-button
          design="four"
          class="ml_15"
          @click="() => changeRoute('editar-campanha', { id: campaign.id })"
        >
          <i class="fal fa-pen" />
        </base-button>
      </div>
      <base-button
        v-if="canUpdate(campaign) && !canPublish(campaign)"
        design="three"
        class="w-100"
        @click="changeRoute('editar-campanha', { id: campaign.id })"
        >Editar campanha</base-button
      >
      <div />
    </div>
  </base-box>
</template>
<script>
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseBadge from '@/components/Badge';
import PerformanceApi from '@/api/modules/performance';

const components = {
  BaseButton,
  BaseBox,
  BaseBadge,
};

export default {
  components,
  props: {
    campaign: { type: Object },
  },
  methods: {
    async updateStatus(campaignParamsItem) {
      if (!campaignParamsItem.action) {
        return;
      }

      await PerformanceApi.updateCampaign(
        {
          status: ['ARC', 'ARD', 'API'].includes(campaignParamsItem.action)
            ? 'ACTIVE'
            : 'SCHEDULED',
        },
        campaignParamsItem.id
      );
      campaignParamsItem.status = ['ARC', 'ARD', 'API'].includes(
        campaignParamsItem.action
      )
        ? 'ACTIVE'
        : 'SCHEDULED';
    },
    canPublish(campaign) {
      if (campaign.status != 'DRAFT') {
        return false;
      }

      if (!campaign.message) {
        return false;
      }
      if (campaign.action == 'API') {
        return true;
      }
      // Se não tiver segmentações configuradas, não pode publicar
      if (!campaign.segmentations || !campaign.segmentations.length) {
        return false;
      }

      // Se for do tipo APA
      if (campaign.type == 'APA') {
        if (
          campaign.send_time == null ||
          !campaign.send_time.date_send ||
          !campaign.send_time.time
        ) {
          return false;
        }
      }

      return true;
    },
    canUpdate(campaign) {
      return campaign.status == 'DRAFT';
    },

    changeRoute(routeName, params = {}) {
      if (params) {
        return this.$router.push({ name: routeName, params });
      }
      return this.$router.push({ name: routeName });
    },
    getActionType(value) {
      switch (value) {
        case 'ARD':
          return 'Ação de recorrência de data';
        case 'ARC':
          return 'Ação de recorrência de conversão';
        case 'APA':
          return 'Ação pontual agendada';
        case 'API':
          return 'Ação pontual imediata';
        default:
          return 'Desconhecido';
      }
    },
    getCampaignStatus(value) {
      const status = {
        ACTIVE: 'success',
        SCHEDULED: 'exclamation',
        FINISHED: 'pink',
        PROCESSING: 'neutral',
        DRAFT: 'neutral',
        PAUSED: 'neutral',
      };

      return status[value] || 'exclamation';
    },
    getCampaignStatusName(value) {
      const status = {
        ACTIVE: 'Ativo',
        SCHEDULED: 'Agendado',
        FINISHED: 'Finalizado',
        PROCESSING: 'Processando',
        DRAFT: 'Rascunho',
        PAUSED: 'Pausado',
      };

      return status[value] || 'Erro';
    },
  },
};
</script>
<style scoped>
.box-campaign .header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ffffff17;
  padding-bottom: 20px;
}

.field-title.coupon-code {
  font-size: 16px;
  font-weight: 900;
  line-height: 19px;
}
.field-title {
  text-transform: uppercase;
  color: var(--label-secondary);
  font-size: 12px;
  font-weight: bold;
  line-height: 15px;
}
.field-title + p {
  font-size: 12px;
  line-height: 15px;
  color: var(--label-primary);
  margin-top: 5px;
}

.megaphone-icon {
  color: var(--label-secondary);
  margin-right: 10px;
  font-size: 19px;
}

.funnels {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.funnel {
  border-radius: 5px;
  width: 100%;
}
.funnel-value {
  padding: 15px 20px;
  color: var(--default);
  border-radius: 5px 5px 0px 0px;
  min-height: 55px;
  border: 1px solid #515159;
  border-bottom: none;
}
.funnel.active .funnel-value {
  border: 1px solid #ff338240;
  border-bottom: none;
}
.funnel-value p {
  font-size: 20px;
  line-height: 24px;
  font-weight: 900;
}
.funnel-value p.empty {
  color: #999999;
  text-align: center;
  font-weight: normal;
}
.funnel-name {
  background: #77777708;
  padding: 10px 20px;
  color: var(--default-hover);
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #515159;
  border-top: none;
}
.funnel.active .funnel-name {
  border: 1px solid #ff338240;
  border-top: none;
  background: #ff33821f;
}

.funnel-name i {
  font-size: 1.4em;
  color: var(--default);
}
.funnel-name p {
  text-transform: uppercase;
  font-size: 1.2em;
  line-height: 15px;
  font-weight: bold;
}
.funnels .line {
  border: none;
  border-bottom: 2px dotted #999999;
  height: 0px;
  width: 50px;
}
.funnels .line.active {
  border-bottom: 2px dotted var(--default);
}

@media screen and (max-width: 991px) {
  .funnels {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  .funnels .line {
    height: 0px;
    width: 20px;
    margin: auto;
    transform: rotate(90deg) translateX(-10px);
  }
  .funnels .funnel {
    margin-bottom: 20px;
    text-align: center;
  }
  .funnel .funnel-name {
    justify-content: center;
  }
}
</style>
